import { Pipe, PipeTransform } from '@angular/core';

/**
 * A pipe to conditionally display a User's full or partial name.
 */
@Pipe({ standalone: true, name: 'fullName' })
export class UserFullNamePipe implements PipeTransform {
  transform(firstName: string, lastName: string): string {
    if (!firstName && !lastName) {
      return '';
    }

    if (firstName) {
      const name = firstName;
      return lastName ? name + ' ' + lastName : name;
    } else {
      //in this case, lastName must be a valid string.
      return lastName;
    }
  }
}
